module.exports = __webpack_public_path__ + "static/media/meta.1b666728.jpg";